/**
 * Texte de consentement affiche au signataire avant de signer.
 *
 * La version est enregistree avec la signature (preuve de ce qui a ete accepte) et doit figurer dans la
 * liste des versions acceptees par l'API (apps/api/src/consent.ts). Toute modification du texte
 * ci-dessous impose une NOUVELLE version, ajoutee aux deux endroits : un test verifie la coherence.
 */
export const CONSENT_VERSION = '2026-10-v2';

export const CONSENT_TEXT =
  "Je certifie avoir lu et compris le document dans son intégralité. " +
  "Je consens librement et de manière éclairée à apposer ma signature électronique " +
  "sur ce document. Je comprends que cette signature a une valeur juridique. " +
  "Le cas échéant, mon tracé ou mon nom saisi n'est que l'apparence visuelle de ma signature : " +
  "elle est prouvée par le certificat et l'horodatage du document.";
